import { produce } from 'immer';

import { BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_SUCCESS } from '@app/store/actionTypes';
import { StatusAction } from '@app/store/bulkRequest/requestTasks/status/actions';
import TaskProgressStatus from '@app/store/bulkRequest/requestTasks/status/TaskProgressStatus';

export interface StatusState {
  canceled: TaskProgressStatus | null;
  cancelingFailed: TaskProgressStatus | null;
  cancelingReady: TaskProgressStatus | null;
  failed: TaskProgressStatus | null;
  pause: TaskProgressStatus | null;
  pending: TaskProgressStatus | null;
  ready: TaskProgressStatus | null;
  success: TaskProgressStatus | null;
  totalCount: number | null;
}

const initialState: StatusState = {
  canceled: null,
  cancelingFailed: null,
  cancelingReady: null,
  failed: null,
  pause: null,
  pending: null,
  ready: null,
  success: null,
  totalCount: null,
};

export default function reducer(state: StatusState = initialState, action: StatusAction) {
  switch (action.type) {
    case BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_SUCCESS:
      return produce(state, () => {
        const { status, totalCount } = action.payload;
        const {
          canceled,
          cancelingFailed,
          cancelingReady,
          failed,
          pause,
          pending,
          ready,
          success,
        } = status;
        return {
          canceled,
          cancelingFailed,
          cancelingReady,
          failed,
          pause,
          pending,
          ready,
          success,
          totalCount,
        };
      });
    default:
      return state;
  }
}
